<template>
  <container fluid>
    <CCard>
      <CCardBody>
        <span class="text-muted font-weight-bold">{{ title }}</span>
        <div @click="goToSalesProfit()" class="puntero mt-3">
          <i class="bi bi-graph-up-arrow h2 text-success mr-3"></i>
          <strong class="h4">Utilidad {{ formatter.format(profitMargin, 2) }}%</strong>
        </div>
        <div class="mt-3">
          <span>Valor de Ventas:</span>
          <strong class="text-info ml-1">${{ merchandiseValue }}</strong>
        </div>
        <div>
          <span>Valor de Costos:</span>
          <strong class="text-warning ml-1">${{ costValue }}</strong>
          <CProgress 
            class="mb-1" 
            color="warning" 
            size="xs"
            :value="salesProfitShare" 
          />
        </div>
        <div>
          <span>Valor Utilidad:</span>
          <strong class="text-success ml-1">${{ profitValue }}</strong>
          <CProgress 
            class="mb-1" 
            color="success" 
            size="xs"
            :value="profitMargin" 
          />
        </div>
      </CCardBody>
    </CCard>

    <LoadingCover spinner="dotsbar" v-show="loading" />
  </container>
</template>
<script>
  import { 
    formatter, 
    dividedValueToShow 
  } from "@/general";
  import { dataCostoVentasDocumentos } from "@/apiData";

  import LoadingCover from "@/components/containers/LoadingCover.vue";

  export default {
    name: 'SalesProfitPanel',
    props: {
      title: String,
      initialDate: String,
      finalDate: String,
      typeUtility: String,
      staffGroupId: String,
      employeeId: String,
      divisorValues: Number
    },
    data() {
      return {
        formatter,
        loading: false,
        merchandiseValue: 0,
        costValue: 0,
        profitValue: 0,
        profitMargin: 0,
        salesProfitShare: 0
      }
    },
    components: {
      LoadingCover
    },
    methods: {
      async getDataSalesAndCosts() {
        this.loading = true;

        try {
          const parameters = {
            "Fecha_Inicial": this.initialDate,
            "Fecha_Final": this.finalDate,
            "Tipo_Reporte": "T",
            "Tipo_Utilidad": this.typeUtility,
            "Id_GrupoPersonal": this.staffGroupId,
            "Id_Personal": this.employeeId
          }

          const { response } = await dataCostoVentasDocumentos(this, parameters);

          console.log('response', response);

          this.merchandiseValue = response[0].Valor_Mercancia;
          this.costValue = response[0].Valor_Costo;
          this.profitValue = response[0].Valor_Utilidad;
          this.profitMargin = response[0].Porcentaje_Utilidad;
          this.salesProfitShare = ((this.costValue / this.merchandiseValue) * 100);

          this.merchandiseValue = dividedValueToShow(this.merchandiseValue);
          this.costValue = dividedValueToShow(this.costValue);
          this.profitValue = dividedValueToShow(this.profitValue);

        } catch (error) {
          console.log(error)          
        } finally {
          this.loading = false;
        }
      }
    },
    mounted() {
      this.getDataSalesAndCosts();
    }
  }
</script>
